import React from 'react';

// @ts-ignore
import Icon from 'assets/images/trojan_logo.svg';

interface Props {
  height: number;
}

const TrojanLogoIcon: React.FC<Props> = ({ height }) => {
  return <img src={Icon} height={height} alt="Mouse Icon" />;
};

export default TrojanLogoIcon;
